import React, { forwardRef } from "react"
import { classNames } from "../../utils"
import { FlexColumn, FlexColumnProps } from "../FlexColumn/FlexColumn"

export type VerticalAlignedProps = FlexColumnProps

export const VerticalAligned = forwardRef<HTMLDivElement, VerticalAlignedProps>(
  function VerticalAligned({ className, ...rest }, ref) {
    return (
      <FlexColumn
        className={classNames("justify-center", className)}
        ref={ref}
        {...rest}
      />
    )
  },
)
